import { render, staticRenderFns } from "./AppCustomerStartNewOrder.vue?vue&type=template&id=43981ab1&"
import script from "./AppCustomerStartNewOrder.vue?vue&type=script&lang=js&"
export * from "./AppCustomerStartNewOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports